import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Media from "@/components/sections/Media";
import Reviews from "@/components/sections/Reviews";
import Booking from "@/components/sections/Booking";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative bg-[#050505] text-[#F5F5F0]">
      <Header />
      <main>
        <Hero />

        {/* Marquee */}
        <div
          data-testid="brand-marquee"
          className="relative border-y border-[#C5A059]/15 py-6 overflow-hidden bg-[#050505]"
        >
          <div className="flex marquee-track whitespace-nowrap gap-12 will-change-transform">
            {Array.from({ length: 2 }).flatMap((_, i) =>
              [
                "Mystery",
                "Mentalism",
                "Sleight of Hand",
                "Stage Illusion",
                "Private Engagements",
                "Theatre",
                "Storytelling",
              ].map((w, j) => (
                <span
                  key={`${i}-${j}-${w}`}
                  className="font-display text-3xl md:text-4xl text-[#F5F5F0]/80 flex items-center gap-12"
                >
                  {w}
                  <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059]" />
                </span>
              )),
            )}
          </div>
        </div>

        <About />
        <Media />
        <Reviews />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
